import { SiTiktok } from "@icons-pack/react-simple-icons";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { CliNav } from "@/landing/components/CliNav";

export const Route = createFileRoute(
  "/_authenticated/(wonda)/_wonda/publish/tiktok",
)({
  component: PublishTikTokLayout,
});

function PublishTikTokLayout() {
  return (
    <>
      <CliNav />
      <div className="flex min-h-[100dvh] flex-col px-4 py-8">
        <div className="mx-auto w-full max-w-5xl">
          <h1 className="mb-6 flex items-center gap-2 text-2xl font-semibold">
            <SiTiktok className="size-6" />
            Post to TikTok
          </h1>
          <Outlet />
        </div>
      </div>
    </>
  );
}
